const BaseUrl = 'https://todo-manager-back.onrender.com'
// const BaseUrl='http://localhost:4000'
export default BaseUrl;